import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PresetDirective, PresetsDirective } from './presets.directive';
import { DateRangePickerComponent } from './daterangepicker.component';
/**
 * NgModule definition for the DateRangePicker component.
 */
export class DateRangePickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DateRangePickerComponent,
        PresetDirective,
        PresetsDirective
    ],
    exports: [
        DateRangePickerComponent,
        PresetDirective,
        PresetsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DateRangePickerModule_tsickle_Closure_declarations() {
/** @type {?} */
DateRangePickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateRangePickerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
